const getCurrentUrl = () => {
  if (typeof window === "undefined") {
    return new URL("https://dummy.dev");
  }
  return new URL(window.location.href);
};

type GetLoginUrlOptions = {
  forAccountMerge?: boolean;
  getSignupUrl?: boolean;
};
const getLoginUrl = (
  redirectToUrl?: URL,
  opts?: GetLoginUrlOptions,
) => {
  const o = opts || {};

  if (typeof window === "undefined" && !redirectToUrl) {
    return "";
  }
  const url = redirectToUrl || new URL(window.location.href);
  const encodedRedirectToUrl = encodeURIComponent(url.toString());

  let authUrl = "/user/login";
  if (o.getSignupUrl) {
    authUrl = "/user/signup";
  }

  const loginUrl = new URL(authUrl, "https://dummy.dev");
  loginUrl.searchParams.set("redirectTo", encodedRedirectToUrl);
  if (o.forAccountMerge) {
    loginUrl.searchParams.set("forAccountMerge", "true");
  }

  return `${loginUrl.pathname}${loginUrl.search}`;
};

const getRedirectUrl = () => {
  if (typeof window === "undefined") {
    return "";
  }
  const url = new URL(window.location.href);

  const redirectUrl = url.searchParams.get("redirectTo");
  return redirectUrl || "/";
};

export { getCurrentUrl, getLoginUrl, getRedirectUrl };
